import {combine} from 'effector';

import {fetchChecksGrid} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ChecksGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

const domain = rootDomain.createDomain('ChecksListDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchChecksGrid,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<ChecksGridRawRow> | null>(null);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    showConfigBlock: showConfigBlock$,
    dataLoading: fetchDataFx.pending,
});
